module.exports = __webpack_public_path__ + "static/childprotection_card_img1@2x-625cedbdd4573249e08c9ef3d0c2a520.jpg";